<template>
  <header id="header__nav">
    <header class="app__header__ernest">
      <div>
        <v-icon>mdi-apps</v-icon>
      </div>
      <div>
        <div><span>{{ $t('app.ernestHeader.tools') }}</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>
    <nav>
      <ul>
        <li>
          <span class="toolbar__item">
            <router-link :to="{name: 'home'}">
              {{ $t('app.nav.dashboard') }}
            </router-link>
          </span>
        </li>
        <li>
          <span class="toolbar__item">{{ $t('app.nav.question.name') }}</span>
          <ul>
            <li>
              <span class="toolbar__item">
                <router-link :to="{name: 'questionsList'}">
                  {{ $t('app.nav.question.show.name') }}
                </router-link>
              </span>
            </li>
            <li>
              <span class="toolbar__item">
                <router-link :to="{name: 'questionLikertCreation'}">
                  {{ $t('app.nav.question.likert.name') }}
                </router-link>
              </span>
            </li>
            <li>
              <span class="toolbar__item">
                <router-link :to="{name: 'questionMcqCreation'}">
                  {{ $t('app.nav.question.mcq.name') }}
                </router-link>
              </span>
            </li>
            <li>
              <span class="toolbar__item">
                <router-link :to="{name: 'questionOpenCreation'}">
                  {{ $t('app.nav.question.open.name') }}
                </router-link>
              </span>
            </li>
          </ul>
        </li>
        <li>
          <span class="toolbar__item">{{ $t('app.nav.questionnaire.name') }}</span>
          <ul>
            <li>
              <span class="toolbar__item">
                <router-link :to="{name: 'questionnaireList'}">
                  {{ $t('app.nav.questionnaire.show.name') }}
                </router-link>
              </span>
            </li>
            <li>
              <span class="toolbar__item">
                <router-link :to="{name: 'questionnaireInit'}">
                  {{ $t('app.nav.questionnaire.create.name') }}
                </router-link>
              </span>
            </li>
            <li>
              <span class="toolbar__item">
                <router-link :to="{name: 'home_user'}">
                  {{ $t('app.nav.questionnaire.test.name') }}
                </router-link>
              </span>
            </li>
          </ul>
        </li>
      </ul>
    </nav>

    <header class="app__header__ernest" v-if="questionnaireDisplay">
      <div>
        <u-icon>Ù</u-icon>
      </div>
      <div>
        <div><span>{{ $t('app.nav.questionnaire.header') }}</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>
    <nav v-if="questionnaireDisplay">
      <ul>
        <li>
          <span class="toolbar__item">{{ $t('app.nav.questionnaire.detail.select.name') }}</span>
        </li>
        <li class="toolbar__item__repository">{{ questionnaireName }}</li>
        <li>
          <!--          <span class="toolbar__item">{{ $t('app.nav.questionnaire.detail.modify.name') }}</span>-->
          <ul>
            <li>
              <span class="toolbar__item">
                <router-link
                  :to="{ name: 'questionnairePublication', params: {id: questionnaireId}}">
                  {{ $t('app.nav.questionnaire.detail.modify.options.name') }}
                </router-link>
              </span>
            </li>
            <li>
              <span class="toolbar__item">
                <router-link :to="{ name: 'questionnaireCreation', params: {id: questionnaireId}}">
                  {{ $t('app.nav.questionnaire.detail.modify.modify.name') }}
                </router-link>
              </span>
            </li>
          </ul>
        </li>
      </ul>
    </nav>

    <header class="app__header__ernest">
      <div>
        <u-icon>æ</u-icon>
      </div>
      <div>
        <div><span>{{ $t('app.nav.repository.header') }}</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>
    <nav>
      <ul>
        <li>
          <span class="toolbar__item">{{ $t('app.nav.repository.selected') }}</span>
        </li>
        <li class="toolbar__item__repository">{{ repositoryName }}</li>
        <li>
          <ul>
            <li>
              <span class="toolbar__item">
                <router-link :to="{ name: 'repositoryDetail' }">
                  {{ $t('app.nav.repository.show.name') }}
                </router-link>
              </span>
            </li>
            <li v-if="multipleRepositories">
              <span class="toolbar__item">
                <router-link :to="{ name: 'repositorySelect' }"
                             @click.native="resetQuestionnaireSelection">
                  {{ $t('app.nav.repository.change.name') }}
                </router-link>
              </span>
            </li>
          </ul>
        </li>
        <li class="toolbar__item__mt" v-if="repositoryDetailDisplay">
          <span
            class="toolbar__item">{{ $t('app.nav.repository.questionnaireFilter.label') }}</span>
          <ul>
            <li>
              <u-select
                :items="questionnaireList"
                :no-data-text="this.$t('app.nav.repository.questionnaireFilter.noData')"
                v-model="questionnaireFilterId"
                item-text="label"
                item-value="id"
                clearable
                color="valid"
                @change="selectQuestionnaire(questionnaireFilterId)"
              />
            </li>
          </ul>
        </li>
      </ul>
    </nav>

    <div class="app__ernest__credits" v-if="user.isStaff && user.staffStatus">
      <header class="app__header__ernest">
        <div>
          <v-icon>mdi-copyright</v-icon>
        </div>
        <div>
          <div><span>{{ $t('app.ernestHeader.credits')}}</span></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div></div>
      </header>

      <section class="app__section__ernest" v-html="staticText"></section>
    </div>
  </header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'NavStaff',
  data () {
    return {
      questionnaireFilterId: null,
      staticText: ''
    }
  },
  computed: {
    ...mapGetters('Repositories', [
      'repositories',
      'repositorySelected'
    ]),
    ...mapGetters('Questionnaires', [
      'questionnaire',
      'questionnaires'
    ]),
    ...mapGetters('User', [
      'user'
    ]),
    multipleRepositories () { return this.repositories.length > 1 },
    questionnaireDisplay () {
      return this.$route.name === 'questionnaireCreation' ||
        this.$route.name === 'questionnairePublication'
    },
    questionnaireId () {
      return this.questionnaire.id
    },
    questionnaireList () {
      return this.questionnaires.filter(q => q.repository === this.repositorySelected.id)
    },
    questionnaireName () {
      return this.questionnaire.label
    },
    repositoryDetailDisplay () { return this.$route.name === 'repositoryDetail' },
    repositoryName () {
      return this.repositorySelected
        ? this.repositorySelected.name
        : this.$t('app.nav.repository.noSelection')
    }
  },
  async created () {
    await this.axios({
      method: 'GET',
      url: 'statictexts/credits/'
    }).then(response => {
      this.staticText = response.data.text
    })

    await this.loadUser()
  },
  methods: {
    ...mapActions('Repositories', [
      'selectQuestionnaire'
    ]),
    ...mapActions('User', [
      'loadUser',
      'toggleUserStatus'
    ]),
    resetQuestionnaireSelection () {
      this.selectQuestionnaire(null)
      this.questionnaireFilterId = null
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "style";
  @import "../../../assets/style/styleAppErnest";

  .app__ernest__credits {
    .app__header__ernest {
      margin-top: 30px;
    }
  }

  .app__header__ernest:not(:first-child) {
    margin-top: 30px;
  }

  #header__nav {
    nav {
      ul {
        .toolbar__item__mt {
          margin-top: 15px;

          ul {
            padding-left: 0;
          }
        }
      }
    }
  }
</style>
